import FilePreview from "components/FilePreview/FilePreview";
import FilePreview2 from "components/FilePreview/FilePreview2";
import { MecordColors } from "Constants/Color";
import React, { useState } from "react";
import { Badge, Card, Col, Container, Row, Table } from "react-bootstrap";

interface KYCDetailsViewProps {
  data?: any;
}

const KYCDetails: React.FC<KYCDetailsViewProps> = ({ data }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [activeFile, setActiveFile] = useState<{
    url: string;
    name: string;
  } | null>(null);

  const openFile = (url: string, name: string) => {
    setActiveFile({ url, name });
    setShowPreview(true);
  };

  console.log("data.other_documents", data.other_documents);
  return (
    <>
      <style>
        {`
                /* Optional – use only if needed */
.common-table {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
}

.common-table thead th {
  background-color: ${MecordColors.LightGrayColor};
  color: ${MecordColors.NormalText};
  font-weight: 500;
}

.common-table tbody tr:hover {
  background-color: #fff5f5;
}

.common-table td,
.common-table th {
  vertical-align: middle;
}

            `}
      </style>
      <Card>
        <Card.Body>
          {/* KYC Status */}
          <Row className="mb-4">
            <Col md={12}>
              <h6 style={{ display: "inline" }} className="mb-3">
                KYC Status :{" "}
              </h6>
              <Badge bg={data?.is_kyc_approved ? "success" : "warning"}>
                {data?.is_kyc_approved ? "KYC Approved" : "KYC Pending"}
              </Badge>
            </Col>
          </Row>

          <hr />

          {/* KYC Documents Table */}
          <Row>
            <Col md={12}>
              <h5 className="mb-3">KYC Documents</h5>
              <div className="table-responsive">
                <Table className="common-table" striped bordered hover>
                  <thead>
                    <tr>
                      <th>Document Type</th>
                      <th>Document Number</th>
                      <th>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* PAN Document */}
                    {data?.is_pan_details && (
                      <tr>
                        <td>PAN</td>
                        <td>{data?.pan_document_name || "—"}</td>
                        <td>
                          {data?.pan_document_url && (
                            <>
                              <FilePreview2 file={data?.pan_document_url} />
                            </>
                          )}
                        </td>
                      </tr>
                    )}

                    {/* GST Document */}
                    {data?.is_gst_details && (
                      <tr>
                        <td>GST</td>
                        <td>{data?.gst_document_name || "—"}</td>
                        <td>
                          {data?.gst_document_url && (
                            <FilePreview2 file={data?.gst_document_url} />
                          )}
                        </td>
                      </tr>
                    )}

                    {/* CIN Document */}
                    {data?.is_cin_details && (
                      <tr>
                        <td>CIN</td>
                        <td>{data?.cin_document_name || "—"}</td>
                        <td>
                          {data?.cin_document_url && (
                            <FilePreview2 file={data?.cin_document_url} />
                          )}
                        </td>
                      </tr>
                    )}

                    {/* Show message if no KYC details */}
                    {!data?.is_pan_details &&
                      !data?.is_gst_details &&
                      !data?.is_cin_details && (
                        <tr>
                          <td colSpan={5} className="text-center text-muted">
                            No KYC documents available
                          </td>
                        </tr>
                      )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>

          <hr />

          {/* Other Documents Table */}
          {data?.other_documents && data.other_documents.length > 0 && (
            <Row>
              <Col md={12}>
                <h5 className="mb-3">Other Documents</h5>
                <div className="table-responsive">
                  <Table className="common-table" striped bordered hover>
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Document Type</th>
                        <th>Document Number</th>
                        <th>Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.other_documents.map((doc: any, index: number) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{doc.document_type || "—"}</td>
                          <td>{doc.document_number || "—"}</td>
                          <td>
                            {doc.document_url ? (
                              <FilePreview2 file={doc?.document_url} />
                            ) : (
                              <FilePreview2 file={doc?.document_file} />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      <FilePreview
        show={showPreview}
        fileUrl={activeFile?.url || null}
        fileName={activeFile?.name}
        onClose={() => setShowPreview(false)}
      />
    </>
  );
};

export default KYCDetails;
